import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;
const getPublishedData = (pageNum, pageSize, searchText) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.GET_PUBLISHED_DATA(
      pageNum,
      pageSize,
      searchText
    ),
    "",
    cancelToken
  );
};

export default getPublishedData;
